import classNames from 'classnames';
import QRCode from 'qrcode';
import { FC, useLayoutEffect, useMemo, useRef } from 'react';

import variables from '../../../styles/variables.module.scss';

import styles from './QrCode.module.scss';

type QrCodeProps = {
  className?: string;
  data: string;
};

const CANVAS_SQUARE_SIZE = 20;

export const QrCode: FC<QrCodeProps> = (props) => {
  const { className, data } = props;

  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  const qrCode = useMemo(() => {
    return QRCode.create(data).modules;
  }, [data]);

  useLayoutEffect(() => {
    const canvas = canvasRef.current;

    if (!canvas) {
      return;
    }

    const ctx = canvas.getContext('2d');

    if (!ctx) {
      return;
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = variables.Color_LightGray500;

    for (let i = 0; i < qrCode.data.length; i++) {
      const x = i % qrCode.size;
      const y = Math.floor(i / qrCode.size);
      const bitValue = qrCode.data[i];

      if (bitValue) {
        ctx.fillRect(x * CANVAS_SQUARE_SIZE, y * CANVAS_SQUARE_SIZE, CANVAS_SQUARE_SIZE, CANVAS_SQUARE_SIZE);
      }
    }
  }, [qrCode.data, qrCode.size]);

  return (
    <div className={classNames(styles.root, className)}>
      <canvas
        className={styles.canvas}
        ref={canvasRef}
        width={qrCode.size * CANVAS_SQUARE_SIZE}
        height={qrCode.size * CANVAS_SQUARE_SIZE}
      />
    </div>
  );
};
